"use client";

import { c as _c } from "react/compiler-runtime";
import { GridColumns, GridRows } from "@visx/grid";
import { useId } from "react";
import { chartCssVars, useChart } from "./chart-context";
export interface GridProps {
  /** Show horizontal grid lines. Default: true */
  horizontal?: boolean;
  /** Show vertical grid lines. Default: false */
  vertical?: boolean;
  /** Number of horizontal grid lines. Default: 5 */
  numTicksRows?: number;
  /** Number of vertical grid lines. Default: 10 */
  numTicksColumns?: number;
  /** Explicit tick values for horizontal grid lines. Overrides numTicksRows. */
  rowTickValues?: number[];
  /** Grid line stroke color. Default: var(--chart-grid) */
  stroke?: string;
  /** Grid line stroke opacity. Default: 1 */
  strokeOpacity?: number;
  /** Grid line stroke width. Default: 1 */
  strokeWidth?: number;
  /** Grid line dash array. Default: "4,4" for dashed lines */
  strokeDasharray?: string;
  /** Enable horizontal fade effect on grid rows (fades at left/right). Default: true */
  fadeHorizontal?: boolean;
  /** Enable vertical fade effect on grid columns (fades at top/bottom). Default: false */
  fadeVertical?: boolean;
}
export function Grid(t0) {
  const $ = _c(42);
  const {
    horizontal: t1,
    vertical: t2,
    numTicksRows: t3,
    numTicksColumns: t4,
    rowTickValues,
    stroke: t5,
    strokeOpacity: t6,
    strokeWidth: t7,
    strokeDasharray: t8,
    fadeHorizontal: t9,
    fadeVertical: t10
  } = t0;
  const horizontal = t1 === undefined ? true : t1;
  const vertical = t2 === undefined ? false : t2;
  const numTicksRows = t3 === undefined ? 5 : t3;
  const numTicksColumns = t4 === undefined ? 10 : t4;
  const stroke = t5 === undefined ? chartCssVars.grid : t5;
  const strokeOpacity = t6 === undefined ? 1 : t6;
  const strokeWidth = t7 === undefined ? 1 : t7;
  const strokeDasharray = t8 === undefined ? "4,4" : t8;
  const fadeHorizontal = t9 === undefined ? true : t9;
  const fadeVertical = t10 === undefined ? false : t10;
  const {
    xScale,
    yScale,
    innerWidth,
    innerHeight,
    orientation,
    barScale
  } = useChart();
  const isHorizontalBarChart = orientation === "horizontal" && barScale;
  const columnScale = isHorizontalBarChart ? yScale : xScale;
  const uniqueId = useId();
  const hMaskId = `grid-rows-fade-${uniqueId}`;
  const hGradientId = `${hMaskId}-gradient`;
  const vMaskId = `grid-cols-fade-${uniqueId}`;
  const vGradientId = `${vMaskId}-gradient`;
  let t11;
  if ($[0] !== fadeHorizontal || $[1] !== hGradientId || $[2] !== hMaskId || $[3] !== horizontal || $[4] !== innerHeight || $[5] !== innerWidth) {
    t11 = horizontal && fadeHorizontal && <defs><linearGradient id={hGradientId} x1="0%" x2="100%" y1="0%" y2="0%"><stop offset="0%" style={{
          stopColor: "white",
          stopOpacity: 0
        }} /><stop offset="10%" style={{
          stopColor: "white",
          stopOpacity: 1
        }} /><stop offset="90%" style={{
          stopColor: "white",
          stopOpacity: 1
        }} /><stop offset="100%" style={{
          stopColor: "white",
          stopOpacity: 0
        }} /></linearGradient><mask id={hMaskId}><rect fill={`url(#${hGradientId})`} height={innerHeight} width={innerWidth} x="0" y="0" /></mask></defs>;
    $[0] = fadeHorizontal;
    $[1] = hGradientId;
    $[2] = hMaskId;
    $[3] = horizontal;
    $[4] = innerHeight;
    $[5] = innerWidth;
    $[6] = t11;
  } else {
    t11 = $[6];
  }
  let t12;
  if ($[7] !== fadeVertical || $[8] !== innerHeight || $[9] !== innerWidth || $[10] !== vGradientId || $[11] !== vMaskId || $[12] !== vertical) {
    t12 = vertical && fadeVertical && <defs><linearGradient id={vGradientId} x1="0%" x2="0%" y1="0%" y2="100%"><stop offset="0%" style={{
          stopColor: "white",
          stopOpacity: 0
        }} /><stop offset="10%" style={{
          stopColor: "white",
          stopOpacity: 1
        }} /><stop offset="90%" style={{
          stopColor: "white",
          stopOpacity: 1
        }} /><stop offset="100%" style={{
          stopColor: "white",
          stopOpacity: 0
        }} /></linearGradient><mask id={vMaskId}><rect fill={`url(#${vGradientId})`} height={innerHeight} width={innerWidth} x="0" y="0" /></mask></defs>;
    $[7] = fadeVertical;
    $[8] = innerHeight;
    $[9] = innerWidth;
    $[10] = vGradientId;
    $[11] = vMaskId;
    $[12] = vertical;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== fadeHorizontal || $[15] !== hMaskId || $[16] !== horizontal || $[17] !== innerWidth || $[18] !== numTicksRows || $[19] !== rowTickValues || $[20] !== stroke || $[21] !== strokeDasharray || $[22] !== strokeOpacity || $[23] !== strokeWidth || $[24] !== yScale) {
    t13 = horizontal && <g mask={fadeHorizontal ? `url(#${hMaskId})` : undefined}><GridRows numTicks={rowTickValues ? undefined : numTicksRows} scale={yScale} stroke={stroke} strokeDasharray={strokeDasharray} strokeOpacity={strokeOpacity} strokeWidth={strokeWidth} tickValues={rowTickValues} width={innerWidth} /></g>;
    $[14] = fadeHorizontal;
    $[15] = hMaskId;
    $[16] = horizontal;
    $[17] = innerWidth;
    $[18] = numTicksRows;
    $[19] = rowTickValues;
    $[20] = stroke;
    $[21] = strokeDasharray;
    $[22] = strokeOpacity;
    $[23] = strokeWidth;
    $[24] = yScale;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== columnScale || $[27] !== fadeVertical || $[28] !== innerHeight || $[29] !== numTicksColumns || $[30] !== stroke || $[31] !== strokeDasharray || $[32] !== strokeOpacity || $[33] !== strokeWidth || $[34] !== vMaskId || $[35] !== vertical) {
    t14 = vertical && columnScale && typeof columnScale === "function" && <g mask={fadeVertical ? `url(#${vMaskId})` : undefined}><GridColumns height={innerHeight} numTicks={numTicksColumns} scale={columnScale} stroke={stroke} strokeDasharray={strokeDasharray} strokeOpacity={strokeOpacity} strokeWidth={strokeWidth} /></g>;
    $[26] = columnScale;
    $[27] = fadeVertical;
    $[28] = innerHeight;
    $[29] = numTicksColumns;
    $[30] = stroke;
    $[31] = strokeDasharray;
    $[32] = strokeOpacity;
    $[33] = strokeWidth;
    $[34] = vMaskId;
    $[35] = vertical;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== t11 || $[38] !== t12 || $[39] !== t13 || $[40] !== t14) {
    t15 = <g className="chart-grid">{t11}{t12}{t13}{t14}</g>;
    $[37] = t11;
    $[38] = t12;
    $[39] = t13;
    $[40] = t14;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  return t15;
}
Grid.displayName = "Grid";
export default Grid;